'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'conveyor-belt-boxes';
var width = 640;
var height = 512;
var aliases = ["conveyor-belt-alt"];
var unicode = 'f46f';
var svgPathData = ['M544 320H96c-54.4 0-96 41.6-96 96s41.6 96 96 96h448c54.4 0 96-41.6 96-96S598.4 320 544 320zM128 448c-19.2 0-32-12.8-32-32s12.8-32 32-32s32 12.8 32 32S147.2 448 128 448zM320 448c-19.2 0-32-12.8-32-32s12.8-32 32-32s32 12.8 32 32S339.2 448 320 448zM512 448c-19.2 0-32-12.8-32-32s12.8-32 32-32s32 12.8 32 32S531.2 448 512 448z', 'M288 0H96C78.33 0 64 14.33 64 32v192c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32V32C320 14.33 305.7 0 288 0zM544 64h-128c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V96C576 78.33 561.7 64 544 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faConveyorBeltBoxes = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;